document.addEventListener('alpine:init', () => {
    let pathURL = window.location.pathname;
    let darkPath = pathURL.includes('/apps/');
    let darkPath2 = pathURL.includes('challenge');
    let e = document.createElement('div');
    e.innerHTML = '<div x-init="$store.dark.add()"></div>';
    if (darkPath || darkPath2) {
        document.querySelector('main').appendChild(e);
    }
})